module.exports = __webpack_public_path__ + "media/images/flags/64/El-Salvador-8a4360c3c3a2a4e02c5f8c46880ddba6.png";